module.exports = __webpack_public_path__ + "static/media/jarvix-logo-white.b4ff77c7.svg";